import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "./../component/Header";
import Footer from "./../component/Footer";
import ProductCard from "./../component/ProductCard";
import ProductCardSkeleton from "./../component/ProductCardSkeleton";
import $ from "jquery";
import { API_BASE_URL } from "../utils/app_url";
import { useLanguage } from "../context/LanguageContext";
import { useAuth } from "../context/AuthContext";
import { NotificationManager } from "react-notifications";

const StoreProductsListing = () => {
  const { storeId, type = "bestsellers" } = useParams();
  const { user } = useAuth();
  const { selectedLanguage, langJson } = useLanguage();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sortKey, setSortKey] = useState("default");
  const [storeName, setStoreName] = useState("");

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}frontend/store/products`, {
        method: "POST",
        body: JSON.stringify({
          store_id: storeId,
          type: type,
          sort_key: sortKey,
          lang: selectedLanguage,
          user_id: user?.id,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();
      setProducts(data.data.products);
      setStoreName(data.data.store_name);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [type, sortKey, selectedLanguage, user?.id, storeId]);

  const handleAddWishlist = async (productId) => {
    if (!user) {
      $(".loginLink").click();
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}frontend/wishlists`, {
        method: "POST",
        body: JSON.stringify({
          product_id: productId,
          lang: selectedLanguage,
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.authorisation.token}`,
        },
      });

      const res = await response.json();
      NotificationManager.success(res.msg);
    } catch (e) {
      console.error(e);
    }
  };

  const handleRemoveWishlist = async (wishlistId) => {
    if (!user) return;

    try {
      const response = await fetch(`${API_BASE_URL}frontend/wishlists/${wishlistId}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${user.authorisation.token}`,
        },
      });

      const res = await response.json();
      NotificationManager.success(res.msg);
    } catch (e) {
      console.error(e);
    }
  };

  const getTypeLabel = () => {
    switch (type) {
      case "bestsellers":
        return langJson?.bestsellers ?? "Bestsellers";
      case "new":
        return langJson?.new ?? "New";
      case "sale":
        return langJson?.sale ?? "Sale";
      default:
        return "Products";
    }
  };

  return (
    <>
      <Header />
      <div className="productListing">
        <div className="container-fluid">
          {/* Type Tabs */}
          <div className="storeProductTabs">
            <Link
              to={`/stores/${storeId}/bestsellers`}
              className={`tab-link ${type === "bestsellers" ? "active" : ""}`}
            >
              {langJson?.bestsellers ?? "Bestsellers"}
            </Link>
            <Link
              to={`/stores/${storeId}/new`}
              className={`tab-link ${type === "new" ? "active" : ""}`}
            >
              {langJson?.new ?? "New"}
            </Link>
            <Link
              to={`/stores/${storeId}/sale`}
              className={`tab-link ${type === "sale" ? "active" : ""}`}
            >
              {langJson?.sale ?? "Sale"}
            </Link>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="prdtListHead">
                <h1>{storeName} - {getTypeLabel()}</h1>
                <div className="prdtSort">
                  <select
                    value={sortKey}
                    onChange={(e) => setSortKey(e.target.value)}
                  >
                    <option value="default">{langJson?.defaultsort ?? "Default"}</option>
                    <option value="latest">{langJson?.latest ?? "Latest"}</option>
                    <option value="oldest">{langJson?.oldest ?? "Oldest"}</option>
                    <option value="price_low_to_high">{langJson?.pricelowtohigh ?? "Price: Low to High"}</option>
                    <option value="price_high_to_low">{langJson?.pricehightolow ?? "Price: High to Low"}</option>
                  </select>
                </div>
              </div>

              {loading ? (
                <ul className="productList">
                  {[...Array(12)].map((_, i) => (
                    <li key={i}>
                      <ProductCardSkeleton />
                    </li>
                  ))}
                </ul>
              ) : products.length > 0 ? (
                <ul className="productList">
                  {products.map((product, index) => (
                    <li key={index}>
                      <ProductCard
                        product={product}
                        handleAddWishlist={handleAddWishlist}
                        handleRemoveWishlist={handleRemoveWishlist}
                      />
                    </li>
                  ))}
                </ul>
              ) : (
                <div className="noProducts">
                  <p>{langJson?.noproductsfound ?? "No products found"}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default StoreProductsListing;
